import { IArtWorkResponse } from 'types/voting'
import { API_PATHS } from '~constants'
import { fireAnalyticsEvent } from '~analyticsUtils'
import { LeaderboardProps } from '~types'

export const fetchSubmissionsByGroup = async (group: string, isPast: boolean = false): Promise<IArtWorkResponse[]> => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_ENDPOINT}${
      isPast ? API_PATHS.GET_PAST_SUBMISSIONS : API_PATHS.GET_SUBMISSIONS
    }${group}`
  )
  const submissions = await response.json()

  const mappedSubmissions = submissions.map((submission: any) => {
    return {
      ...submission,
      video: {
        ...submission.video,
        loDefVideo: submission.video?.url ?? ''
      }
    }
  })

  return mappedSubmissions
}

export const fetchLeaderBoardByGroup = async (group: string): Promise<LeaderboardProps[]> => {
  const response = await fetch(`${process.env.NEXT_PUBLIC_API_ENDPOINT}${API_PATHS.LEADERBOARD_REPORT}${group}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  const { data } = await response.json()

  return data
}

export interface ISubmitXOVote {
  name: string
  email: string
  videoId: string
  videoEducationLevel: number
}

export const submitXOVote = async ({ name, email, videoId, videoEducationLevel }: ISubmitXOVote) => {
  fireAnalyticsEvent(null, null, {
    clickTracking: 'hero:header',
    clickType: 'header',
    linkLocation: 'header',
    linkModule: 'content:cta'
  })

  const rawResponse = await fetch(`${process.env.NEXT_PUBLIC_API_ENDPOINT}${API_PATHS.CAST_VOTE}`, {
    method: 'PATCH',
    body: JSON.stringify({
      name,
      email,
      submissionId: videoId,
      educationLevel: videoEducationLevel
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-vote-api-key': `${process.env.NEXT_PUBLIC_SERVER_VOTE_API_KEY}`
    }
  })
  const response = await rawResponse.json()

  if (response.status === '1001') {
    return response
  } else if (response.status === '1009') {
    throw new Error('This email has already voted for this cohort!')
  } else if (response.status === '1003') {
    throw new Error('The voting deadline has passed.')
  } else {
    throw new Error('Something went wrong!')
  }
}
